import { h } from '@stencil/core'; // eslint-disable-line @typescript-eslint/no-unused-vars
import { ResultItemContext } from '../../../types';

const CategoryResultItemTemplate = (context: ResultItemContext) => (
  <result-item
    type={context.item.type}
    class={context.hidden ? 'hidden' : ''}
    href={context.item.links['pip']} // TODO make the "pip" attribute access type-safe, maybe similar to the ProductIndexItem schema
    key={context.key}
    onClick={() => context.ref.onSelectItem(context.item, context.position, context.queryID, context.listType)}
    tabindex="0"
  >
    <result-item-headline>{context.item.name}</result-item-headline>
    {context.item.category.trim() != '' ? (
      <result-item-category>
        {context.ref.textResources.results.category.preposition} {context.item.category}
      </result-item-category>
    ) : (
      ''
    )}
  </result-item>
);

export default CategoryResultItemTemplate;
